var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import GA4React from "ga-4-react";
import App from "./App";
import GA4_CODE from "./constants/ga4.constant";
import "./App.scss";
const container = document.getElementById("root");
const root = createRoot(container);
const ga4react = new GA4React(GA4_CODE);
(() => __awaiter(void 0, void 0, void 0, function* () {
    yield ga4react.initialize();
    root.render(_jsx(StrictMode, { children: _jsx(App, {}) }));
}))();
